import React from 'react';
import DeviceList from '../../components/devices/DeviceList';
import Page from '../../components/layout/Page';
import PageHeader from '../../components/layout/PageHeader';
import { useTranslation } from '../../i18n/i18n';
import { DeviceType } from '../../models/device';
import { geoDetailUrl } from '../../routes.constants';

const GeoDevicesPage = () => {
  const { t } = useTranslation('devices');
  return (
    <Page variant="list">
      <PageHeader
        crumbs={[{ label: t('breadcrumb') }, { label: t('geo.breadcrumb') }]}
        title={t('geo.title')}
        subtitle={t('geo.subtitle')}
      />
      <DeviceList type={DeviceType.GEO} kind="geo" detailUrl={geoDetailUrl} />
    </Page>
  );
};

export default GeoDevicesPage;
